<template>
  <div>
    <ContentHeader />
    <div class="content-container">
      <ItemOrderTemplate @toFavourite="toFavourite"/>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import ItemOrderTemplate from './components/item-order-template'
export default {
  name: 'MenuListTemplate',
  components: {
    ContentHeader,
    ItemOrderTemplate
  },
  methods: {
    toFavourite () {
      this.$router.push({ name: 'menu-favourite' })
    }
  }
}
</script>
